import { NoteComposer } from "./NoteComposer";
import { NoteItem } from "./NoteItem";
import { Column, ErrorText, LoadingIndicator } from "@/components";
import { useUserSheet } from "@/components/user-sheet/userSheetContext";

import { useGetUserNotes } from "@/hooks/queries/useGetUserNotes";
import { cn } from "@/lib/utils";

export const NotesTab = ({
  companyName,
  jobTitle,
  userId,
}: {
  companyName: string;
  jobTitle: string;
  userId: number;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: notes, isError, isPending } = useGetUserNotes({ userId });

  /* Context */
  const { contentPaddingClassName, isReadOnly } = useUserSheet();

  /* Render */
  const renderComposer = () => {
    if (isReadOnly) return null;

    return (
      // Pinned to the bottom of the tab's scroll viewport.
      <Column
        className={cn(
          "sticky bottom-0 bg-white pb-7",
          notes?.length ? "pt-4" : "pt-0",
        )}
      >
        <NoteComposer
          companyName={companyName}
          jobTitle={jobTitle}
          userId={userId}
        />
      </Column>
    );
  };

  const render = () => {
    if (isPending) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <LoadingIndicator variant="medium" />
        </Column>
      );
    }
    if (isError) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <ErrorText errorMessage="Error retrieving notes." />
        </Column>
      );
    }
    return (
      <Column className={cn("pt-7", contentPaddingClassName)}>
        <Column>
          {notes.map((note) => (
            <NoteItem key={note.id} note={note} />
          ))}
        </Column>
        {renderComposer()}
      </Column>
    );
  };

  return render();
};
